<template>
  <div class="inline-block">
    <div class="fullscreen-btn" @click="clickFullscreen">
      <svg-icon
        :iconClass="fullscreen ? 'fullscreen-exit' : 'fullscreen'"
        className="fullcreen-icon"
      ></svg-icon>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull'
export default {
  data() {
    return {
      fullscreen: false
    }
  },
  mounted: function() {
    this.checkFullscreen()
    document.addEventListener('fullscreenchange', this.checkFullscreen)
  },
  methods: {
    checkFullscreen() {
      if (document.fullscreenElement) {
        this.fullscreen = true
      } else {
        this.fullscreen = false
      }
    },
    clickFullscreen() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: 'Your browser can not support full screen',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
      this.fullscreen = !this.fullscreen
    }
  }
}
</script>
